import { render, staticRenderFns } from "./PageManagerGrade.vue?vue&type=template&id=994175c0&scoped=true"
import script from "./PageManagerGrade.vue?vue&type=script&lang=js"
export * from "./PageManagerGrade.vue?vue&type=script&lang=js"
import style0 from "./PageManagerGrade.vue?vue&type=style&index=0&id=994175c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "994175c0",
  null
  
)

export default component.exports